module.exports = __webpack_public_path__ + "static/media/cookies.b1662ca9.svg";